// Cart JS Tax
(function() {
function updateTaxMessage() {
fetch('/cart.js')
.then(function(res) { return res.json(); })
.then(function(cart) {
var totalPrice = cart.total_price / 100;
var tax = totalPrice * 5 / 105;
var message = "Including <span class='gst-amount'>₹" + tax.toFixed(2) + "</span> in taxes";
document.querySelectorAll('.tax-message').forEach(function(el) {
el.innerHTML = message;
});
});
}
function debounce(fn, delay) {
var timer;
return function() {
clearTimeout(timer);
timer = setTimeout(fn, delay);
};
}

var debouncedUpdate = debounce(updateTaxMessage, 300);

updateTaxMessage();
['cart:updated', 'cart:refresh', 'alpine:initialized', 'shopify:section:load'].forEach(function(evt) {
document.addEventListener(evt, debouncedUpdate);
});
var originalFetch = window.fetch;
window.fetch = function() {
var url = arguments[0];
if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
return originalFetch.apply(this, arguments).then(function(response) {
var clone = response.clone();
clone.json().then(debouncedUpdate).catch(function(){});
return response;
});
}
return originalFetch.apply(this, arguments);
};

function observeCartPage() {
var cartContainer = document.querySelector(
'cart-items, .cart__items, [data-cart-items], form[action="/cart"]'
);
if (cartContainer) {
var observer = new MutationObserver(debouncedUpdate);
observer.observe(cartContainer, { childList: true, subtree: true });
}
}
observeCartPage();
document.addEventListener('shopify:section:load', observeCartPage);

})();